import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles } from '@/mocks/articles';
import { siteConfig } from '@/mocks/site';

const articleDetailImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=warm%20family%20gathering%20young%20mother%20in%20law%20smiling%20with%20son%20in%20law%20modern%20living%20room%20soft%20natural%20light%20editorial%20photography%20cozy%20atmosphere%20beige%20and%20cream%20tones%20minimalist%20interior%20genuine%20emotional%20connection&width=1200&height=600&seq=detail-1&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=two%20men%20having%20respectful%20conversation%20in%20bright%20modern%20apartment%20warm%20lighting%20professional%20but%20relaxed%20atmosphere%20beige%20and%20soft%20green%20tones%20editorial%20style%20clean%20composition&width=1200&height=600&seq=detail-2&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=three%20generations%20family%20sitting%20together%20in%20bright%20living%20room%20warm%20sunlight%20streaming%20through%20windows%20peaceful%20atmosphere%20grandmother%20daughter%20and%20grandchild%20smiling%20soft%20beige%20and%20cream%20palette&width=1200&height=600&seq=detail-3&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=two%20women%20one%20older%20one%20younger%20having%20tea%20together%20in%20bright%20modern%20kitchen%20sunlight%20through%20window%20harmonious%20atmosphere%20soft%20warm%20tones%20editorial%20photography&width=1200&height=600&seq=detail-4&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=person%20sitting%20peacefully%20by%20window%20journaling%20morning%20light%20warm%20atmosphere%20minimalist%20interior%20self%20care%20concept%20soft%20cream%20and%20sage%20green%20tones%20calm%20editorial&width=1200&height=600&seq=detail-5&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=family%20sitting%20in%20circle%20having%20open%20conversation%20in%20bright%20living%20room%20sunlight%20streaming%20through%20large%20windows%20warm%20atmosphere%20active%20listening%20editorial%20cream%20and%20terracotta&width=1200&height=600&seq=detail-6&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=elegant%20middle%20aged%20woman%20sitting%20by%20window%20thoughtful%20expression%20soft%20morning%20light%20modern%20apartment%20warm%20beige%20and%20cream%20tones%20editorial%20portrait%20photography%20intimate&width=1200&height=600&seq=detail-7&orientation=landscape',
  8: 'https://readdy.ai/api/search-image?query=festive%20family%20dinner%20table%20with%20warm%20candlelight%20multiple%20generations%20enjoying%20meal%20together%20cozy%20dining%20room%20holiday%20atmosphere%20soft%20warm%20lighting%20cream%20and%20gold%20editorial&width=1200&height=600&seq=detail-8&orientation=landscape',
};

const relatedCardImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=warm%20family%20gathering%20young%20mother%20in%20law%20smiling%20with%20son%20in%20law%20modern%20living%20room%20soft%20natural%20light%20cozy%20atmosphere%20beige%20and%20cream%20tones&width=600&height=400&seq=related-1&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=two%20men%20having%20respectful%20conversation%20in%20bright%20modern%20apartment%20warm%20lighting%20professional%20but%20relaxed%20atmosphere%20beige%20and%20soft%20green%20tones&width=600&height=400&seq=related-2&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=three%20generations%20family%20sitting%20together%20in%20bright%20living%20room%20warm%20sunlight%20streaming%20through%20windows%20peaceful%20atmosphere%20soft%20beige%20and%20cream&width=600&height=400&seq=related-3&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=two%20women%20one%20older%20one%20younger%20having%20tea%20together%20in%20bright%20modern%20kitchen%20sunlight%20through%20window%20harmonious%20atmosphere%20soft%20warm%20tones&width=600&height=400&seq=related-4&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=person%20sitting%20peacefully%20by%20window%20journaling%20morning%20light%20warm%20atmosphere%20minimalist%20interior%20self%20care%20concept%20soft%20cream%20and%20sage%20green&width=600&height=400&seq=related-5&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=family%20sitting%20in%20circle%20having%20open%20conversation%20in%20bright%20living%20room%20sunlight%20streaming%20warm%20atmosphere%20active%20listening%20cream%20and%20terracotta&width=600&height=400&seq=related-6&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=elegant%20middle%20aged%20woman%20sitting%20by%20window%20thoughtful%20expression%20soft%20morning%20light%20modern%20apartment%20warm%20beige%20and%20cream%20tones&width=600&height=400&seq=related-7&orientation=landscape',
  8: 'https://readdy.ai/api/search-image?query=festive%20family%20dinner%20table%20with%20warm%20candlelight%20multiple%20generations%20enjoying%20meal%20together%20cozy%20dining%20room%20holiday%20atmosphere&width=600&height=400&seq=related-8&orientation=landscape',
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-16 md:pt-18 min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold font-heading text-foreground-950 mb-3">文章未找到</h1>
            <p className="text-foreground-600 mb-6">该文章不存在或已被删除</p>
            <Link to="/" className="px-6 py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, 3);

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: article.date,
    publisher: {
      '@type': 'Organization',
      name: siteConfig.name,
    },
    image: articleDetailImages[article.id],
    url: `${siteConfig.url}/article/${article.slug}`,
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, item: { '@id': siteConfig.url, name: '首页' } },
      { '@type': 'ListItem', position: 2, item: { '@id': `${siteConfig.url}/category/${article.category}`, name: article.categoryName } },
      { '@type': 'ListItem', position: 3, item: { '@id': `${siteConfig.url}/article/${article.slug}`, name: article.title } },
    ],
  };

  return (
    <>
      <SEOHead
        title={article.title}
        description={article.excerpt}
        keywords={article.tags.join(',') + ',年轻的岳母,家庭代际关系'}
        canonicalPath={`/article/${article.slug}`}
        ogType="article"
        ogImage={articleDetailImages[article.id]}
        schema={[articleSchema, breadcrumbSchema]}
      />
      <Navbar />
      <main className="pt-16 md:pt-18">
        <article>
          <div className="relative w-full h-[350px] md:h-[450px] overflow-hidden">
            <img
              src={articleDetailImages[article.id]}
              alt={article.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-transparent to-black/50"></div>
          </div>

          <div className="max-w-3xl mx-auto px-4 md:px-6 -mt-20 relative z-10">
            <div className="bg-background-50 rounded-lg p-6 md:p-8">
              <Breadcrumb
                items={[
                  { label: '首页', path: '/' },
                  { label: article.categoryName, path: `/category/${article.category}` },
                  { label: article.title },
                ]}
              />

              <div className="mt-4 flex flex-wrap items-center gap-2 mb-4">
                {article.tags.map((tag) => (
                  <span key={tag} className="text-xs px-3 py-1 rounded-full bg-accent-100 text-accent-700">
                    {tag}
                  </span>
                ))}
              </div>

              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 leading-tight mb-4">
                {article.title}
              </h1>

              <div className="flex items-center gap-4 text-sm text-foreground-500 pb-6 mb-8 border-b border-background-200/70">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-line text-foreground-400"></i>
                  {article.author}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-calendar-line text-foreground-400"></i>
                  {article.date}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line text-foreground-400"></i>
                  {article.readTime} 分钟阅读
                </span>
              </div>

              <div
                className="prose-custom text-foreground-800 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />
            </div>
          </div>
        </article>

        {relatedArticles.length > 0 && (
          <section className="py-12 md:py-16 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-6 md:mb-8">
                相关推荐
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.id}
                    to={`/article/${ra.slug}`}
                    className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
                  >
                    <div className="h-44 overflow-hidden">
                      <img
                        src={relatedCardImages[ra.id] || relatedCardImages[1]}
                        alt={ra.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="text-sm font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                        {ra.title}
                      </h3>
                      <div className="flex items-center gap-2 text-xs text-foreground-500">
                        <span>{ra.date}</span>
                        <span>·</span>
                        <span>{ra.readTime} 分钟</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
    </>
  );
}